import { BsXCircle } from 'react-icons/bs'
import MessagePage from '../../components/custom/Shared/MessagePage/MessagePage'

const ExpiredSubscriptionPage = () => {
  return (
    <MessagePage
      titleId="Subscription-Cancellation-Link-Expired"
      messageIds={[
        'The-link-to-cancel-your-subscription-has-expired.',
        'Please-request-a-new-cancellation-link-or-contact-support.',
      ]}
      icon={BsXCircle}
      variant="red"
      redirectPath="mailto:Info@rosaas.app"
      redirectLabelId="Contact-Support"
    />
  )
}

export default ExpiredSubscriptionPage
